import { render, staticRenderFns } from "./susdonationsfunding.vue?vue&type=template&id=9f7bbfba&scoped=true&"
import script from "./susdonationsfunding.vue?vue&type=script&lang=js&"
export * from "./susdonationsfunding.vue?vue&type=script&lang=js&"
import style0 from "./susdonationsfunding.vue?vue&type=style&index=0&id=9f7bbfba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7bbfba",
  null
  
)

export default component.exports